/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Or_Continue_WithInputs */

const en_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or continue with`)
};

const pl_auth_or_continue_with = /** @type {(inputs: Auth_Or_Continue_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lub kontynuuj przez`)
};

/**
* | output |
* | --- |
* | "Or continue with" |
*
* @param {Auth_Or_Continue_WithInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_or_continue_with = /** @type {((inputs?: Auth_Or_Continue_WithInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Or_Continue_WithInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_or_continue_with(inputs)
	return en_auth_or_continue_with(inputs)
});